import { Layout, Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { colors, gradient } from 'styles/colors';

export const StaticPageTitle: React.FC = ({ children }) => {
  const { minTablet } = useBreakpoints();

  return (
    <StaticTitleWrapper>
      <StaticTitleBackground />
      <StaticTitle level={1} size={minTablet ? 50 : 24}>
        {children}
      </StaticTitle>
    </StaticTitleWrapper>
  );
};

export const StaticTitleWrapper = styled(Layout.Content)`
  padding: 80px 16px;
  position: relative;
`;

export const StaticTitleBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${colors.primary};
`;

interface StaticTitleProps {
  size: number;
}

export const StaticTitle = styled(Typography.Title)<StaticTitleProps>`
  &.ant-typography {
    position: relative;
    font-size: ${({ size }) => `${size}px`};
    color: ${colors.white};
    margin: 0 auto;
    text-align: center;
  }
`;
